function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.4948 4.83325H1.66667C0.746528 4.83434 0.00108507 5.57978 0 6.49992V17.4678C0.00108507 18.3879 0.746528 19.1334 1.66667 19.1345H15.4948C16.4147 19.1334 17.1604 18.3879 17.1615 17.4678V6.49992C17.1604 5.57978 16.4147 4.83434 15.4948 4.83325Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 11.8203,
  y: 0.595947,
  width: 2,
  height: 22.4736,
  rx: 1,
  transform: "rotate(17.6703 11.8203 0.595947)",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M18.2715 14.2668L23.9989 17.3937V6.61011L18.2715 9.73706V14.2668Z",
  fill: "currentColor"
});

var SvgVideoCameraOff = function SvgVideoCameraOff(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVideoCameraOff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/video-camera-off.2cf5a33f.svg";
export { ForwardRef as ReactComponent };